import { connect } from 'react-redux';
import DeletePersonnelDialog from '../../components/DeletePersonnedDialog';
import { submitMode } from '../../constants';

import {
  openDeletePersonnelDialogDispatch,
  submitPersonnelDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    personnel: state.personnel.newPersonnel.item,
    open: state.personnel.newPersonnel.showDeletePersonnelDialog,
    isUpdating: state.personnel.newPersonnel.isSaving,
    errorMessage: state.personnel.newPersonnel.errorMessage
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    showDialog: (open, personnel) => {
      dispatch(openDeletePersonnelDialogDispatch(open));
    },
    onConfirmPersonnelDelete: (personnel) => {
      const mode = submitMode.UPDATE;
      dispatch(submitPersonnelDispatch(personnel, mode));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeletePersonnelDialog);
